// ------- Servidor Prod -------
export const urlGlobal2 ="https://apiv2.globalnet.net.ar/api";
export const urlDecidir = 'https://live.decidir.com/api/v2';
export const publicKey = 'e84d783e93d84561ad33f96cb51acec6';
export const urlPagos = 'https://api.pagos360.com/payment-request/pdf';